import React from 'react';
import { FaPhoneAlt, FaWhatsapp } from 'react-icons/fa';
import '../Css/FloatingButtons.css';

const FloatingButtons = () => {
  const phoneNumber = "+918849189845";
  const whatsappMessage = "Hello! I'm interested in your courses. Can you please provide more information?";

  return (
    <div className="floating-buttons">
      {/* Call Button - Left Bottom */}
      <div className="float-btn call-btn">
        <a href={`tel:${phoneNumber}`} className="float-link">
          <FaPhoneAlt />
          <span className="btn-label">Call Us</span>
        </a>
      </div>

      {/* WhatsApp Button - Right Bottom */}
      <div className="float-btn whatsapp-btn">
        <a 
          href={`https://wa.me/${phoneNumber.replace('+', '')}?text=${encodeURIComponent(whatsappMessage)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="float-link"
        >
          <FaWhatsapp />
          <span className="btn-label">WhatsApp</span>
        </a>
      </div>
    </div>
  );
};

export default FloatingButtons;